import axios from 'axios';
import Vue from 'vue';

import config from '../config/config';

// 重新授权
const reauthorize = () => {
	if (config.wechat.oauth()) {
		Vue.prototype.$localStorage.setItem('rurel', window.location.href);
		window.location.replace(config.wechat.oauth());
	}
};

useRequestConfig();
// 配置request请求配置
function useRequestConfig() {
	axios.interceptors.request.use(
		function (options: any) {
			options.headers = {
				Authorization: `Bearer ${Vue.prototype.$localStorage.getItem('token') || ''}`,
				'x-tenant': `6c3fa2b0-c5be-471d-8c73-4a831e22aea9`
			};
			if (process.env.VUE_APP_BLUE_DOT === 'develop') {
				// 测试环境区分
				options.url = options.url.replace('/api/', '/api-dev/');
			} else {
				// options.url = options.url.replace('/api/', '/api-dev/');
			}
			return options;
		},
		function (error: any) {
			return Promise.reject(error);
		}
	);

	axios.interceptors.response.use(
		function (response) {
			return response;
		},
		function (error) {
			if (error?.response?.status == 401) {
				// console.log('token过期');
				reauthorize();
			}
			return Promise.reject(error);
		}
	);
}
